<template>
  <SoPageWithHeader title="Configurations">
    <SoButton
      type="text"
      title="Back to services"
      prepend-icon="arrow-left"
      class="mb-4 px-0"
      data-testid="service-config-back-btn"
      :to="{ name: RouteNames.AdminServices }"
    />

    <div class="pt-4">
      <ServiceConfigStatsBar
        :total-count="stats?.totalCount ?? 0"
        :active-count="stats?.activeCount ?? 0"
        :loading="statsQuery?.isFetching ?? false"
        data-testid="service-config-stats-bar"
      />

      <ServiceConfigTable data-testid="service-config-table" />
    </div>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import ServiceConfigStatsBar from "@/views/admin/serviceConfig/components/ServiceConfigStatsBar.vue"
  import ServiceConfigTable from "@/views/admin/serviceConfig/components/ServiceConfigTable.vue"
  import {
    ServiceConfigService,
    ConfigStats,
  } from "@/services/admin/ServiceConfigService"
  import { QueryResult } from "@/api/utils/types"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      ServiceConfigStatsBar,
      ServiceConfigTable,
    },
    data() {
      return {
        RouteNames,
        statsQuery: null as QueryResult<ConfigStats> | null,
      }
    },
    computed: {
      stats(): ConfigStats | null {
        return this.statsQuery?.data ?? null
      },
    },
    mounted() {
      this.statsQuery = ServiceConfigService.getStats()
    },
  })
</script>
